import { createSlice } from "@reduxjs/toolkit";
import {
  fetchDashboardData,
  fetchDayWiseOrders,
  fetchTotalComplaints,
  fetchTotalCustomers,
  fetchTotalOrders,
  fetchTotalOrdersByServices,
  fetchTotalOrdersByStatus,
} from "./thunks";
import { IDashboardSlice } from "./types";

const initialState: IDashboardSlice = {
  complaints: {
    count: 0,
    rows: [],
  },
  customers: {
    count: 0,
    rows: [],
  },
  orders: {
    count: 0,
    rows: [],
  },
  totalOrders: {
    totalOrders: 0,
    data: [],
  },
  totalComplaints: {
    totalComplaints: 0,
    data: [],
  },
  totalCustomers: {
    totalCustomers: 0,
    data: {
      count: 0,
      rows: [],
    },
  },
  totalOrdersByServices: [],
  totalOrdersByStatus: [],
  dayWiseOrders: {
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear(),
    orders: [],
    totalOrders: 0,
  },
  isError: false,
  isLoading: false,
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    // fetchDashboardData
    builder.addCase(fetchDashboardData.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchDashboardData.fulfilled, (state, action) => {
      state.isLoading = false;
      state.customers = action?.payload?.customer;
      state.orders = action?.payload?.order;
      state.complaints = action?.payload?.complaint;
    });
    builder.addCase(fetchDashboardData.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });

    // fetchTotalOrders
    builder.addCase(fetchTotalOrders.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchTotalOrders.fulfilled, (state, action) => {
      // console.log("fetchTotalOrders", action.payload);
      state.isLoading = false;
      state.totalOrders = action.payload.data;
    });
    builder.addCase(fetchTotalOrders.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });

    // fetchDayWiseOrders handlers
    builder.addCase(fetchDayWiseOrders.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchDayWiseOrders.fulfilled, (state, action) => {
      state.isLoading = false;
      // action.payload is { month, year, orders, totalOrders }
      state.dayWiseOrders = action.payload ?? {
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear(),
        orders: [],
        totalOrders: 0,
      };
    });
    builder.addCase(fetchDayWiseOrders.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
      state.dayWiseOrders = {
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear(),
        orders: [],
        totalOrders: 0,
      };
    });
    // fetchTotalCustomers
    builder.addCase(fetchTotalCustomers.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchTotalCustomers.fulfilled, (state, action) => {
      // console.log("totalCustomers", action.payload);
      state.isLoading = false;
      state.totalCustomers = action.payload;
    });
    builder.addCase(fetchTotalCustomers.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });

    // fetchTotalComplaints
    builder.addCase(fetchTotalComplaints.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchTotalComplaints.fulfilled, (state, action) => {
      state.isLoading = false;
      // console.log("totalComplaints", action.payload);
      state.totalComplaints = action.payload;
    });
    builder.addCase(fetchTotalComplaints.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });

    // fetchTotalOrdersByStatus
    builder.addCase(fetchTotalOrdersByStatus.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchTotalOrdersByStatus.fulfilled, (state, action) => {
      state.isLoading = false;
      state.totalOrdersByStatus = action.payload;
    });
    builder.addCase(fetchTotalOrdersByStatus.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });

    // fetchTotalOrdersByServices
    builder.addCase(fetchTotalOrdersByServices.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchTotalOrdersByServices.fulfilled, (state, action) => {
      state.isLoading = false;
      state.totalOrdersByServices = action.payload;
    });
    builder.addCase(fetchTotalOrdersByServices.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });
  },
});

export const { reducer } = dashboardSlice;
